import { FormManagementProps } from '@/type/form.types';
import { FieldValues, Path } from 'react-hook-form';

export const setGroupRequiredFields = <TSchema extends FieldValues>({
  setValue,
  data,
}: FormManagementProps<TSchema>) => {
  setValue('name' as Path<TSchema>, data.name ?? '');
  setValue('isBranch' as Path<TSchema>, data.isBranch);
  setValue('businessIdNumber' as Path<TSchema>, data.businessIdNumber ?? '');
  setValue('addressLine1' as Path<TSchema>, data.addressLine1 ?? '');
  setValue('postalCode' as Path<TSchema>, data.postalCode ?? '');
  setValue('city' as Path<TSchema>, data.city ?? '');
  setValue('country' as Path<TSchema>, data.country ?? '');
  setValue('phone' as Path<TSchema>, data.phone ?? '');
  setValue('email' as Path<TSchema>, data.email ?? '');
};
